import { render, staticRenderFns } from "./calendarthreewithoutfooter.vue?vue&type=template&id=5b999a7d&scoped=true&"
import script from "./calendarthreewithoutfooter.vue?vue&type=script&lang=js&"
export * from "./calendarthreewithoutfooter.vue?vue&type=script&lang=js&"
import style0 from "./calendarthreewithoutfooter.vue?vue&type=style&index=0&id=5b999a7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b999a7d",
  null
  
)

export default component.exports